<template>
  <div>
    <SBtn
      link-medium
      :color="color"
      data-testid="shared-exit"
      class="mt-n1"
      @click="exitConfirm=true"
    >
      {{ $t('ida.btn.exit') }}
    </SBtn>
    <SubscriptionConfirmationDialog
      :confirm-text="$t('ida.btn.exit')"
      :action-function="exit"
      data-testid="exit-confirm-dialog"
      :show-dialog="exitConfirm"
      :text="$t('p.exitLoseInfo')"
      :title="$t('header.selectionConfirmation')"
      emit-close-on-escape
      @close="exitConfirm = false"
    >
      <template #additional-actions>
        <VRow no-gutters class="py-4">
          <VCol>
            <SBtn link-medium @click="exitConfirm = false">
              {{ $t('input.btn.cancel') }}
            </SBtn>
          </VCol>
        </VRow>
      </template>
    </SubscriptionConfirmationDialog>
  </div>
</template>
<script lang="ts" setup>
import SubscriptionConfirmationDialog from '~/components/base/ConfirmationDialog.vue'

// White on the teal bar at rest (BaseLayout), primary on the white collapsed
// header once scrolled (HeaderLayout), as in nuxt2.
withDefaults(defineProps<{ color?: string }>(), { color: 'white' })

const exitConfirm = ref(false)

const router = useRouter()
const exit = () => {
  router.go(-1)
}
</script>

<style lang='scss' scoped>
</style>
